// extracted by mini-css-extract-plugin
export default {"empower":"Empower_empower__rwl20","head":"Empower_head__Eq6YK","globe":"Empower_globe__7Wovj","powerGrid":"Empower_powerGrid__ekNlZ","card":"Empower_card__9SaHr"};